import { Done } from "@mui/icons-material";
import styled from "styled-components";

interface StyledProps {
  $isPhone?: boolean;
  $opacity?: string;
  $Done?: boolean;
  $isDisabled?: boolean;
}

export const CardContainer = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${({ $isPhone }) => ($isPhone ? "auto" : "167px")};
  min-height: ${({ $isPhone }) => ($isPhone ? "120px" : "auto")};
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: ${({ $Done, $isDisabled }) =>
    $Done ? "#F7F4FF" : $isDisabled ? "#F2F2F2" : "white"};
  // opacity: ${({ $opacity }) => $opacity || 1};
  gap: ${({ $isPhone }) => ($isPhone ? "8px" : "16px")};
  margin-top: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  padding: ${({ $isPhone }) => ($isPhone ? "12px" : "0")};
`;

export const TextContainer = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: ${({ $isPhone }) => ($isPhone ? "12px" : "24px")};
  flex: 1;
`;

export const StepText = styled.span<StyledProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "0.75rem" : "0.875rem")};
  color: #5b3fff;
  margin-top: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")};
`;

export const TitleText = styled.span<StyledProps>`
  font-weight: 700;
  font-size: ${({ $isPhone }) => ($isPhone ? "0.875rem" : "1rem")};
  color: #331860;
  margin-top: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")};
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.3;
  text-decoration: ${({ $Done }) => ($Done ? "line-through" : "none")};
`;

export const DescriptionText = styled.span<StyledProps>`
  font-weight: 300;
  font-size: ${({ $isPhone }) => ($isPhone ? "0.75rem" : "0.875rem")};
  color: #625783;
  white-space: pre-line;
  margin-top: ${({ $isPhone }) => ($isPhone ? "4px" : "8px")};
  line-height: 1.5;
`;

export const ActionButton = styled.button<StyledProps>`
  width: ${({ $isPhone }) => ($isPhone ? "72px" : "97px")};
  height: ${({ $isPhone }) => ($isPhone ? "24px" : "32px")};
  border-radius: 24px;
  color: white;
  background-color: ${({ $isDisabled }) => ($isDisabled ? "#ccc" : "#5b3fff")};
  outline: none;
  border: none;
  margin-top: ${({ $isPhone }) => ($isPhone ? "8px" : "12px")};
  cursor: pointer;
  font-size: ${({ $isPhone }) => ($isPhone ? "0.75rem" : "0.875rem")};
  padding: 0 8px;
  display: ${({ $Done }) => ($Done ? "none" : "")};
`;

export const IconContainer = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $isPhone }) => ($isPhone ? "0 12px" : "0 32px")};
  flex-shrink: 0;
  min-width: ${({ $isPhone }) => ($isPhone ? "80px" : "180px")};
  flex: 0 0 auto;
`;
